module.exports = __webpack_public_path__ + "media/assets/images/icons/profile-generic/avatar-example-5-60c3a59d76c4b67b23520734e04da7b2.png";